import { useState } from "react";
import QRCodeDisplay from "../../../components/QRCodeDisplay";
import AddressFlow from "../../../components/AddressFlow";
import { useHost } from "../../../hooks/userInfoService";
import { useLoad } from "../../../hooks/useLoad";
import { qrBaseUrl } from "../../../Endpoint";
import { useOwnerRestaurantSelection } from "../../../hooks/useOwnerRestaurantSelection";
import { useUser } from "../../../hooks/useUser";
import { useResto } from "../../../hooks/useResto";

export const Qrpage = ({ showInfo = false }) => {
    const { infoHost, updateRestoWork } = useHost();
    const { isOwner, isResto, userId } = useUser();
    const { resto } = useResto();
    const { selectedOwnerRestaurantId, selectedOwnerRestaurant } = useOwnerRestaurantSelection();
    const { load } = useLoad();
    const [isQr, setIsQr] = useState(true);
    const handleUpdate = () => {
        setIsQr(!isQr);
    }

    const handlePlaceSelected = async ({ name, formatted_address, country, place_id }) => {
        await updateRestoWork({ name, formatted_address, country, place_id });
        await load();
        setIsQr(true);
    }

    if (!isQr) {
        return <AddressFlow canceUpdate={handleUpdate} onPlaceSelected={handlePlaceSelected} />
    }

    const qrTargetId = isOwner
        ? userId || selectedOwnerRestaurantId || selectedOwnerRestaurant?._id || selectedOwnerRestaurant?.id || selectedOwnerRestaurant?.place_id || selectedOwnerRestaurant?.restoId
        : isResto
            ? userId || resto?._id || resto?.id
            : infoHost?._id;
    const qrName = isOwner
        ? selectedOwnerRestaurant?.name || "tienda"
        : isResto
            ? resto?.name || "tienda"
            : infoHost?.name;
    const qrAddress = isOwner
        ? selectedOwnerRestaurant?.address || ""
        : isResto
            ? resto?.address || ""
            : infoHost?.address || "";

    return <>
        {qrTargetId && <QRCodeDisplay
            text={`${qrBaseUrl}/w/${qrTargetId}`}
            userName={qrName}
            address={qrAddress}
            onUpdate={handleUpdate}
            sizeCm={3}
            showUpdateButton={false}
            showInfo={showInfo}
        />}
    </>
}   
